import React, { useContext } from 'react';
import { Camera } from 'react-feather';

import Button from '../../buttons/Button';
import AppContext from 'contexts/AppContext';

function AddPhotosButton({ openPhotoUploadModal, poi }) {
    const { state } = useContext(AppContext);
    const { photoContest } = state;
    return (
        <Button
            variant="contained"
            color="secondary"
            onClick={openPhotoUploadModal}
            startIcon={photoContest.state !== 'ACTIVE' && <Camera />}
        >
            {photoContest.state == 'ACTIVE' && poi.is_in_contest ? (
                <div className="relative pl-5">
                    <img
                        src="/images/foto-izbor/badge.svg"
                        width="41"
                        height="64"
                        alt=""
                        className="absolute -left-8 -top-2"
                    />
                    <span>Dodaj fotografije in sodeluj</span>
                </div>
            ) : (
                <span>Dodaj fotografije</span>
            )}
        </Button>
    );
}

export default AddPhotosButton;
